import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Scheduler/constants";

export const clearInitialScrapeTasks = createAction(`${moduleSlug}/CLEAR_INITIAL_SCRAPE_TASKS`);

export const getInitialScrapeTasks = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASKS`);
export const getInitialScrapeTasksSuccess = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASKS/SUCCESS`);
export const getInitialScrapeTasksError = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASKS/ERROR`);

export const enableInitialScrapeTasks = createAction(`${moduleSlug}/ENABLE_INITIAL_SCRAPE_TASKS`);
export const enableInitialScrapeTasksSuccess = createAction(`${moduleSlug}/ENABLE_INITIAL_SCRAPE_TASKS/SUCCESS`);
export const enableInitialScrapeTasksError = createAction(`${moduleSlug}/ENABLE_INITIAL_SCRAPE_TASKS/ERROR`);

export const getCountSchedulerList = createAction(`${moduleSlug}/GET_COUNT_SCHEDULER_LIST`);
export const getCountSchedulerListSuccess = createAction(`${moduleSlug}/GET_COUNT_SCHEDULER_LIST/SUCCESS`);
export const getCountSchedulerListError = createAction(`${moduleSlug}/GET_COUNT_SCHEDULER_LIST/ERROR`);

export const setSelectedTasks = createAction(`${moduleSlug}/SET_SELECTED_TASK`);

export const changeEnabledTask = createAction(`${moduleSlug}/CHANGE_ENABLED_TASk`);

export const setStartTasksDialog = createAction(`${moduleSlug}/SET_START_TASKS_DIALOG`);
export const mergeStartTasksDialog = createAction(`${moduleSlug}/MERGE_START_TASKS_DIALOG`);
export const startTasks = createAction(`${moduleSlug}/START_TASKS`);

export const setEditMetadataDialog = createAction(`${moduleSlug}/SET_EDIT_METADATA_DIALOG`);
export const mergeEditMetadataDialog = createAction(`${moduleSlug}/MERGE_EDIT_METADATA_DIALOG`);
export const editMetadata = createAction(`${moduleSlug}/EDIT_METADATA`);

export const setIntervalHoursTasksDialog = createAction( `${moduleSlug}/SET_INTERVAL_HOURS_TASKS_DIALOG` );
export const mergeIntervalHoursTasksDialog = createAction( `${moduleSlug}/MERGE_SET_INTERVAL_HOURS_TASKS` );
export const intervalHours = createAction( `${moduleSlug}/SET_INTERVAL_HOURS_TASK` );

export const setPaginationLimitTasksDialog = createAction( `${moduleSlug}/SET_PAGINATION_LIMIT_TASKS_DIALOG` );
export const mergePaginationLimitTasksDialog = createAction( `${moduleSlug}/MERGE_SET_PAGINATION_LIMIT_TASKS` );
export const paginationLimit = createAction( `${moduleSlug}/SET_PAGINATION_LIMIT_TASK` );

export const setIntervalHoursAllTasksDialog = createAction( `${moduleSlug}/SET_INTERVAL_HOURS_ALL_TASKS_DIALOG` );

export const setPaginationLimitAllTasksDialog = createAction( `${moduleSlug}/SET_PAGINATION_LIMIT_ALL_TASKS_DIALOG` );

export const setInitialScrapeTaskDialog = createAction(`${moduleSlug}/SET_INITIAL_SCRAPE_TASK_DIALOG`);
export const mergeInitialScrapeTaskDialog = createAction(`${moduleSlug}/MERGE_INITIAL_SCRAPE_TASK_DIALOG`);
export const createInitialScrapeTask = createAction(`${moduleSlug}/CREATE_INITIAL_SCRAPE_TASK`);

export const setOneTimeSearchDialog = createAction(`${moduleSlug}/SET_ONE_TIME_SEARCH_DIALOG`);
export const mergeOneTimeSearchDialog = createAction(`${moduleSlug}/MERGE_ONE_TIME_SEARCH`);
export const oneTimeSearch = createAction(`${moduleSlug}/ONE_TIME_SEARCH`);

export const setRescheduleDialog = createAction(`${moduleSlug}/SET_RESCHEDULE_DIALOG`);
export const mergeRescheduleDialog = createAction(`${moduleSlug}/MERGE_RESCHEDULE_DIALOG`);
export const reschedule = createAction(`${moduleSlug}/RESCHEDULE`);

export const setProgressDialog = createAction(`${moduleSlug}/SET_PROGRESS_DIALOG`);
export const mergeProgressDialog = createAction(`${moduleSlug}/MERGE_PROGRESS_DIALOG`);

export const deleteTasks = createAction(`${moduleSlug}/DELETE_TASKS`);
export const setDeleteDialog = createAction(`${moduleSlug}/SET_DELETE_DIALOG`);
export const mergeDeleteDialog = createAction(`${moduleSlug}/MERGE_DELETE_DIALOG`);

export const setScheduleDialog = createAction(`${moduleSlug}/SET_SCHEDULE_DIALOG`);
export const mergeScheduleDialog = createAction(`${moduleSlug}/MERGE_SCHEDULE_DIALOG`);

export const changeAllEnableStatus = createAction(`${moduleSlug}/CHANGE_ALL_ENABLE_STATUS`);
export const updateAllByRequest = createAction(`${moduleSlug}/UPDATE_ALL_BY_REQUEST`);

export const downloadKeywords = createAction(`${moduleSlug}/DOWNLOAD_KEYWORDS`);

export const setDownloadKeywordsDialog = createAction(`${moduleSlug}/SET_DOWNLOAD_KEYWORDS_DIALOG`);
export const mergeDownloadKeywordsDialog = createAction(`${moduleSlug}/MERGE_DOWNLOAD_KEYWORDS_DIALOG`);
